import React, { MouseEvent } from 'react'
import Icon from '@sharedComponents/Icon'
import {usePantameraService} from "@frontendUtils/pantamera-service";

type IInputCheckboxProps = {
    id: string
    className?: string
    disabled?: boolean
    label: any
    hideLabel?: boolean
    checked: boolean
    onChange: any
    disableClickLabel?: boolean
}

const { getCssVariable } = usePantameraService();

const InputCheckbox = ({
                           hideLabel = false,
                           ...props
                       }: IInputCheckboxProps) => {
    const onClickStyledCheckbox = () => {
        const hiddenCheckbox = document.getElementById(props.id)
        hiddenCheckbox && hiddenCheckbox.click()
    }
    
    const colorCheckmarkIcon = getCssVariable('colorCheckmarkIcon');

    return (
        <div className={`checkbox-wrapper ${props.className}`}>
            <input
                className={`checkbox-wrapper__hidden-checkbox`}
                type={'checkbox'}
                checked={props.checked}
                id={props.id}
                onChange={props.onChange}
                disabled={!!props.disabled}
            />
            <div
                onClick={onClickStyledCheckbox}
                className={`checkbox-wrapper__checkbox styled-checkbox ${
                    props.disabled ? 'disabled' : ''
                } ${props.checked ? 'checkbox-wrapper__checkbox--checked' : ''}`}
            >
                <Icon
                    iconName="check"
                    color={colorCheckmarkIcon}
                    size={11}
                />
            </div>
            <label
                className={`checkbox-wrapper__label ${hideLabel ? 'sr-only' : ''}`}
                htmlFor={props.id}
                onClick={(e: MouseEvent<any>) => {
                    if ((e.target as HTMLElement).tagName === 'A') {
                        return
                    }

                    if (props.disableClickLabel) {
                        e.preventDefault()
                    }
                }}
            >
                {props.label}
            </label>
        </div>
    )
}

export default InputCheckbox